export default __webpack_public_path__ + "static/media/nossas_unidades_8.1d212b64.webp";